import { render, staticRenderFns } from "./drop-file.vue?vue&type=template&id=6ac829ec&scoped=true&"
import script from "./drop-file.vue?vue&type=script&lang=js&"
export * from "./drop-file.vue?vue&type=script&lang=js&"
import style0 from "./drop-file.vue?vue&type=style&index=0&id=6ac829ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac829ec",
  null
  
)

export default component.exports